import {CoreResponse, CoreResponseId, CreateCoreResponse, ScopeId} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function list(): Promise<CoreResponse[]> {
  return await platformedClient.internalRequest("get", "/region/{region}/api/vendor_toolkit/core_responses", {});
}

export async function get(coreResponseId: CoreResponseId): Promise<CoreResponse> {
  return await platformedClient.internalRequest("get", "/region/{region}/api/vendor_toolkit/core_responses/{id}", {
    path: {id: coreResponseId},
  });
}

export async function create(payload: CreateCoreResponse): Promise<CoreResponse> {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/vendor_toolkit/core_responses`, {
    body: payload,
  });
  await invalidateQueries([q.vendorToolkit.coreResponses.filter()]);
  return res;
}

export async function delete_(coreResponseId: CoreResponseId) {
  await platformedClient.internalRequest("delete", `/region/{region}/api/vendor_toolkit/core_responses/{id}`, {
    path: {id: coreResponseId},
  });
  await invalidateQueries([
    q.vendorToolkit.coreResponses.filter(),
    q.vendorToolkit.coreResponse.filter(coreResponseId),
  ]);
}

export async function updateQuestionText(coreResponseId: CoreResponseId, questionText: string) {
  await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/core_responses/{id}/question_text`,
    {body: questionText, path: {id: coreResponseId}},
  );
  await invalidateQueries([
    q.vendorToolkit.coreResponses.filter(),
    q.vendorToolkit.coreResponse.filter(coreResponseId),
  ]);
}

export async function updateResponseText(coreResponseId: CoreResponseId, responseText: string) {
  await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/core_responses/{id}/response_text`,
    {body: responseText, path: {id: coreResponseId}},
  );
  await invalidateQueries([
    q.vendorToolkit.coreResponses.filter(),
    q.vendorToolkit.coreResponse.filter(coreResponseId),
  ]);
}

export async function updateLimitedToScopes(coreResponseId: CoreResponseId, scopeIds: ScopeId[] | null) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/core_responses/{id}/limited_to_scopes`,
    {body: scopeIds, path: {id: coreResponseId}},
  );
  await invalidateQueries([
    q.vendorToolkit.coreResponses.filter(),
    q.vendorToolkit.coreResponse.filter(coreResponseId),
  ]);
  return res;
}
